var _path, _path2, _path3, _path4, _path5, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSalesTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 152h-16v-40a72 72 0 00-144 0v40h-16v-40a88 88 0 01176 0z",
    fill: "#fa5d3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471.009 477.1a10 10 0 01-9.959 10.9H376V136h64z",
    fill: "#fa7d29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M408 488H50.95a10 10 0 01-9.959-10.9L72 136h304z",
    fill: "#fa5d3f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.818 424h356.364l-14.546-160H60.364z",
    fill: "#fac850"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312 176h-16v-64a72 72 0 00-144 0v64h-16v-64a88 88 0 01176 0z",
    fill: "#fa7d29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fac850"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 192,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 192,
    r: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fffffe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 322v12a18.021 18.021 0 0018 18h20a2 2 0 012 2v12a2 2 0 01-2 2H88v16h38a18.021 18.021 0 0018-18v-12a18.021 18.021 0 00-18-18h-20a2 2 0 01-2-2v-12a2 2 0 012-2h38v-16h-38a18.021 18.021 0 00-18 18zM207.761 310.06A8 8 0 00200 304h-16a8 8 0 00-7.761 6.06l-16 64A7.977 7.977 0 00160 376v8h16v-7.015L180.246 360h23.508L208 376.985V384h16v-8a7.977 7.977 0 00-.239-1.94zM184.246 344l6-24h3.508l6 24zM256 304h-16v72a8 8 0 008 8h40v-16h-32zM360 320v-16h-48a8 8 0 00-8 8v64a8 8 0 008 8h48v-16h-40v-16h32v-16h-32v-16z"
  }))));
}

export default __webpack_public_path__ + "0800ddffacb8a994e9e2bbc349e793c3.svg";
export { SvgSalesTag as ReactComponent };